module.exports = __webpack_public_path__ + "static/assets/f87904843f21a05464c4acc3ec4d368d.png";